import { useContext } from 'react';
import MentoringProgramContext from './mentoring-program/context';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import ParticipantDotAlias from './mentoring-program/program-configuration/program-profile-setup/program-level/program-level-list/program-level-field/participant-dot-alias';
import { TargetAudience } from 'redux/schemas/models/mentoring-programs';

type AudienceProps = {
  target: TargetAudience;
  className?: string;
};

const Audience = ({ target, className }: AudienceProps) => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { programAlias } = mentoringProgram || {};
  const { mentee, mentor } = programAlias || {};
  const isDeliveredToMentee =
    target === TargetAudience.MENTEE ||
    target === TargetAudience.MENTOR_AND_MENTEE;
  const isDeliveredToMentor =
    target === TargetAudience.MENTOR ||
    target === TargetAudience.MENTOR_AND_MENTEE;

  return (
    <div className={`d-flex gap-2 ${className}`}>
      {isDeliveredToMentee && (
        <ParticipantDotAlias
          alias={mentee.singularizedTitleized}
          role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE}
          className='pt-1'
        />
      )}
      {isDeliveredToMentor && (
        <ParticipantDotAlias
          alias={mentor.singularizedTitleized}
          role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR}
          className='pt-1'
        />
      )}
    </div>
  );
};

export default Audience;
